/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Explainer_Single_DeviceInputs */



/**
* | output |
* | --- |
* | "Only this device can edit the tournament. Other organizers see it locked until you're back online." |
*
* @param {Offline_Explainer_Single_DeviceInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_explainer_single_device = /** @type {((inputs?: Offline_Explainer_Single_DeviceInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Explainer_Single_DeviceInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seul cet appareil peut modifier le tournoi. Les autres organisateurs le voient verrouillé jusqu'à votre retour en ligne.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo este dispositivo puede editar el torneo. Los demás organizadores lo ven bloqueado hasta que vuelva a estar en línea.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Só este dispositivo pode editar o torneio. Os outros organizadores o veem bloqueado até você voltar a ficar online.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo questo dispositivo può modificare il torneo. Gli altri organizzatori lo vedono bloccato finché non torna online.")
	return /** @type {LocalizedString} */ ("Only this device can edit the tournament. Other organizers see it locked until you're back online.")
});